import { post } from '@/util/http'
// 获取菜单信息
export const getMenus = params => post(`/sum/sumMenu/selectPage`, params)

// 获取菜单树信息
export const getMenuTree = params => post(`/sum/sumMenu/selectTree`, params)
